module.exports = __webpack_public_path__ + "assets/img/King Albert Park MRT.1de7439b.jpg";